import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { countryForHostname } from '../../helpers/region'
import gbFlag from '../../assets/images/flags/gb.png'
import ieFlag from '../../assets/images/flags/ie.png'
import gbWlsFlag from '../../assets/images/flags/gb-wls.png'
import deFlag from '../../assets/images/flags/de.png'
import euFlag from '../../assets/images/flags/eu.png'

// PNGs rather than emoji: Windows browsers don't render flag emoji
const FLAGS = {
  gb: gbFlag,
  ie: ieFlag,
  'gb-wls': gbWlsFlag,
  de: deFlag,
  eu: euFlag,
}

// Shows which country's AmbuNet deployment this hostname belongs to. The
// domain fixes the country, so this is display-only, and it renders nothing
// on unrecognised hosts (localhost, dev builds).
export default function CountryIndicator() {
  const country = countryForHostname(window.location.hostname)
  if (!country) return null

  return (
    <Stack direction="row" spacing={0.8} alignItems="center" justifyContent="center">
      <Box
        component="img"
        src={FLAGS[country.code]}
        alt=""
        sx={{
          height: 13,
          width: 'auto',
          borderRadius: 0.4,
          outline: '1px solid rgba(255,255,255,0.25)',
          display: 'block',
        }}
      />
      <Typography variant="caption" sx={{ color: 'white', opacity: 0.75, fontWeight: 600 }}>
        {country.name}
      </Typography>
    </Stack>
  )
}
